module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_8003.0b87ec4e.png";